export default "/img/final2020.png"